import React, { useState } from "react";
import { useFormik } from "formik";
import * as YUP from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { Helmet } from "react-helmet";

export default function ResetPassword() {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  let validationSchema = YUP.object({
    email: YUP.string()
      .matches(emailRegex, "Email is not matched, Please try again!")
      .required("Email is required"),
    password: YUP.string()
      .min(6, "Password must be at least 6 character")
      .required("Password isrequired"),
  });

  let navigate = useNavigate();
  const [error, seterror] = useState(null);
  const [isLodding, setisLodding] = useState(false);

  async function resetSubmit(values) {
    setisLodding(true);
    let { data } = await axios
      .put(
        "https://vehex-production.up.railway.app/user/reset_password",
        values
      )
      .catch((err) => {
        setisLodding(false);
        seterror(err.response.data.message);
      });

    if (data.message === "Try to login now") {
      setisLodding(false);
      navigate("/login");
    }
  }

  let resetPass = useFormik({
    initialValues: {
      email: "",
      code: "",
      password: "",
    },
    validationSchema,
    onSubmit: resetSubmit,
  });

  return (
    <>
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <div className="w-100 bg-black">
        <div className="image w-100 position-relative">
          <div className="overlay">
            <div className="container">
              <div className="w-50 py-4 submitContent box-shadow p-2 mt-2 position-absolute rounded-3">
                {error ? (
                  <div className="alert alert-danger">{error} try again!</div>
                ) : (
                  ""
                )}

                <h2 className="fw-600 mb-3 heading">Reset Password Now</h2>
                <form onSubmit={resetPass.handleSubmit}>
                  <label htmlFor="email" className="fs-4 second-color mt-3">
                    Email :
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control fs-5"
                    value={resetPass.values.email}
                    onBlur={resetPass.handleBlur}
                    onChange={resetPass.handleChange}
                  ></input>
                  {resetPass.errors.email && resetPass.touched.email ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {resetPass.errors.email}
                    </div>
                  ) : (
                    ""
                  )}

                  <label htmlFor="code" className="fs-4 second-color mt-3">
                    Code :
                  </label>
                  <input
                    type="tel"
                    id="code"
                    name="code"
                    className="form-control fs-5"
                    value={resetPass.values.code}
                    onBlur={resetPass.handleBlur}
                    onChange={resetPass.handleChange}
                  ></input>
                  {resetPass.errors.code && resetPass.touched.code ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {resetPass.errors.code}
                    </div>
                  ) : (
                    ""
                  )}

                  <label htmlFor="password" className="fs-4 second-color mt-3">
                    New Password :
                  </label>
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control fs-5"
                      value={resetPass.values.password}
                      onBlur={resetPass.handleBlur}
                      onChange={resetPass.handleChange}
                    ></input>
                    <span
                      className="input-group-text"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={
                          passwordVisible ? "fas fa-eye" : "fas fa-eye-slash"
                        }
                      ></i>
                    </span>
                  </div>
                  {resetPass.errors.password && resetPass.touched.password ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {resetPass.errors.password}
                    </div>
                  ) : (
                    ""
                  )}

                  {isLodding ? (
                    <button type="button" className="btn text-white py-3">
                      <RotatingLines
                        strokeColor="#c2272d"
                        strokeWidth="10"
                        animationDuration="1"
                        width="30"
                        visible={true}
                      />
                    </button>
                  ) : (
                    <>
                      <button
                        disabled={!(resetPass.isValid && resetPass.dirty)}
                        type="submit"
                        className="my-3 main-color fw-500 border-2 me-2"
                      >
                        Change Password
                      </button>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
